import { graphql } from "react-relay";

export const QUERY = graphql`
	query selectMultipleRootNodesForm_PublishedRootQuery {
		...selectMultipleRootNodesField_QueryFragment
	}
`;
